<template>
  <v-app :style="{background: $vuetify.theme.themes[theme].background}">
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <router-link class="white--text" :to="user ? '/home' : '/'">
          <h1 class="app-title">Ceol</h1> 
        </router-link>
      </div>

      <v-spacer></v-spacer>
      <ProfileWidget></ProfileWidget>
    </v-app-bar>

    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import ProfileWidget from '@/layout/ProfileWidget.vue';


export default {
  name: 'App',
  components: {
    ProfileWidget
  },
  data: () => ({
    //
  }),
  mounted() {
    if (this.darkUser)
      this.$vuetify.theme.dark = true;

  },
  computed: {
    // fix for background color
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    darkUser() {
      return this.$store.state.tune.userProfile.user_settings.dark_mode;
    },
    user() {
      return this.$store.state.auth.user
    }
  }
};
</script>
<style lang="scss">
a {
  color: var(--v-primary-base);
  text-decoration: none;
}
.bread {
  border: 1px solid red;
}
@font-face {
    font-family: Gaeilge;
    src: url('~@/assets/fonts/gaeilge.ttf');
}
.app-title {
  font-family: Gaeilge;
}
.debug-btn {
  display: block;
  position: absolute;
  background: white;
  opacity: 0.3;
  &:hover {
    opacity: 1;
  }
  top: 20px;
}
</style>